import React from "react";

import { Tooltip } from "antd";
import moment from "moment";

import StatusTag from "../../Common/components/StatusTag";
import { makeReasonArray, userCorrectionMap } from "../QC/utils";
import { getUser } from "../../../utils/helpers";

import "./QcTooltipContent.css";

/**
 * QC tooltip field mapping:
 * - Software QC: status tag -> qc_result, reason text -> qc_status
 * - AI QC: status tag -> ml_qc_result, text below -> ml_qc_status
 * - Manual QC: status tag -> manual_qc_result, text below -> manual_qc_status,
 *   tooltip "Updated By / Updated At" -> manual_qc_by, manual_qc_at
 */
const QcTooltipContent = ({
  testData,
  // originalTestData,
}) => {
  const {
    ml_correct_by,
    ml_correct_at,
    ml_qc_comments,
    manual_qc_by,
    manual_qc_at,
  } = testData;

  const user = getUser();

  // Get user correction status safely
  const userCorrectionStatus = (testData.user_correction != null && testData.user_correction !== "" && userCorrectionMap[testData.user_correction])
    || (testData.ml_qc_correction != null && testData.ml_qc_correction !== "" && userCorrectionMap[testData.ml_qc_correction])
    || null;

  // Software QC section
  const reasons = makeReasonArray(testData.qc_status);
  const softwareQCSection = (
    <div className="QcTooltipContent__SampleCell__QCSection">
      <div className="QcTooltipContent__SampleCell__QCLabelContainer">
        <div className="QcTooltipContent__SampleCell__QCLabel">
          Software QC:
        </div>
        <StatusTag result={testData.qc_result} type="QC" />
      </div>
      <div className="QcTooltipContent__SampleCell__QCContent">
        {reasons.length ? reasons.map((reason, index_r) => (
          <p key={index_r} className="QcTooltipContent__SampleCellTextLight">
            {reason || "-"}
          </p>
        )) : (
          <p className="QcTooltipContent__SampleCellTextLight">-</p>
        )}
      </div>
    </div>
  );

  // AI QC tooltip title
  const statusTooltipTitle = (ml_correct_at || ml_correct_by || (ml_qc_comments && ml_qc_comments.trim())) ? () => (
    <span>
      {ml_correct_by && (
        <>
          {ml_correct_by}
          <br />
        </>
      )}
      {ml_correct_at && (
        <>
          {moment(ml_correct_at).format("MM/DD/YYYY, h:mm:ss a")}
          <br />
        </>
      )}
      {ml_qc_comments && ml_qc_comments.trim() && `Comment: ${ml_qc_comments}`}
    </span>
  ) : "";

  // AI QC section (only if user has permission)
  const aiQCSection = user.permissionMap.approve_reject_ml_qc_sendreports ? (
    <div className="QcTooltipContent__SampleCell__QCSection">
      <div className="QcTooltipContent__SampleCell__QCLabelContainer">
        <div className="QcTooltipContent__SampleCell__QCLabel">
          AI QC:
        </div>
        <div className="QcTooltipContent__SampleCell__MLQCStatus">
          {statusTooltipTitle ? (
            <Tooltip placement="top" title={statusTooltipTitle}>
              <span>
                <StatusTag result={testData.ml_qc_result} type="QC">
                  {userCorrectionStatus && (
                    <span className="QcTooltipContent__UserCorrectionText">
                      &nbsp; -
                      {" "}
                      {userCorrectionStatus}
                    </span>
                  )}
                </StatusTag>
              </span>
            </Tooltip>
          ) : (
            <StatusTag result={testData.ml_qc_result} type="QC">
              {userCorrectionStatus && (
                <span className="QcTooltipContent__UserCorrectionText">
                  &nbsp; -
                  {" "}
                  {userCorrectionStatus}
                </span>
              )}
            </StatusTag>
          )}
        </div>
      </div>
      <div className="QcTooltipContent__SampleCell__QCContent">
        <p className="QcTooltipContent__SampleCellTextLight">
          {testData.ml_qc_status || "-"}
        </p>
      </div>
    </div>
  ) : null;

  // Manual QC tooltip title (Updated By / Updated At)
  const manualQCTooltipTitle = () => (
    <span>
      Updated By:
      {" "}
      {manual_qc_by || "-"}
      <br />
      Updated At:
      {" "}
      {manual_qc_at ?? "-"}
      <br />
      {/* {originalTestData.tis_pk === testData.tis_pk ? (
          <>
            Assign To:
            {" "}
            {manual_qc_assigned_to_name || "-"}
          </>
        ) : "" } */}
    </span>
  );

  // Manual QC section
  const manualQCSection = (
    <div className="QcTooltipContent__SampleCell__QCSection">
      <div className="QcTooltipContent__SampleCell__QCLabelContainer">
        <div className="QcTooltipContent__SampleCell__QCLabel">
          Manual QC:
        </div>
        {manualQCTooltipTitle ? (
          <Tooltip placement="top" title={manualQCTooltipTitle}>
            <span>
              <StatusTag result={testData.manual_qc_result} type="MANUAL_QC" />
            </span>
          </Tooltip>
        ) : (
          <StatusTag result={testData.manual_qc_result} type="MANUAL_QC" />
        )}
      </div>
      <div className="QcTooltipContent__SampleCell__QCContent">
        <p className="QcTooltipContent__SampleCellTextLight">
          {testData.manual_qc_status || "-"}
        </p>
      </div>
    </div>
  );

  return (
    <div className="QcTooltipContent__SampleCell">
      {softwareQCSection}
      {aiQCSection}
      {manualQCSection}
    </div>
  );
};

export default QcTooltipContent;
